import { Component, OnInit, Input } from '@angular/core';
import { Ditta } from 'my-lib-sanfelici/my-lib-sanfelici';


@Component({
  selector: 'app-ditta-view',
  templateUrl: './ditta-view.component.html',
  styleUrls: ['./ditta-view.component.css']
})
export class DittaViewComponent implements OnInit {
@Input() ditta: Ditta;
  constructor() { }

  ngOnInit() {
  }

}
